// export const environment = {
//   production: true,
//   envName: 'prod',
//   apiKey: 'oZkMxSBspEUspAKG146i5QHrxcQI46pkvXQEf6QmFjvjJLYN4hA47tXMYv1eYovr',
//   baseUrl: 'https://identityrpg.com'
// }
export const environment = {
	envName: 'prod',
	production: true,
	currencies: false,
	baseUrl: 'https://identityrpg.com/api',
	apiKey: '4LZT0pbYEVitk4yYen1GeCdfIaDSpP2RdLW9sWAOU5FGd41A5iqpb6dJ4ZWCQ6GK',
    paypal: {
		client: {
			sandbox: 'Aad4UVzwM2_tWjb-Wy2AvdnNDCki8C78YSmEOlcxizM4RkDY9W201p5N-_kzZqIjHPQnZVyMeYgI3xBy',
			production: 'Aad4UVzwM2_tWjb-Wy2AvdnNDCki8C78YSmEOlcxizM4RkDY9W201p5N-_kzZqIjHPQnZVyMeYgI3xBy'
		},
		env: 'production'
    },
    globalcollect: {
		environment: "PRODUCTION",
		region: "US",
		assetUrl: "https://eu.sandbox.api-ingenico.com",
		clientApiUrl: "https://eu.sandbox.api-ingenico.com"
	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/environment.ts